//Normal messagess
export let Message = {
  requiredMessage: "This field is required",
  loading: "Loading..."
};
